import { render, staticRenderFns } from "./ElderStatis.vue?vue&type=template&id=33ca45eb&scoped=true&"
import script from "./ElderStatis.vue?vue&type=script&lang=js&"
export * from "./ElderStatis.vue?vue&type=script&lang=js&"
import style0 from "./ElderStatis.vue?vue&type=style&index=0&id=33ca45eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ca45eb",
  null
  
)

export default component.exports